{
  "colors": {
    "primitives": {
      "comment": "Raw colour values found, not yet mapped to roles",
      "values": [
        "#8D8D8D",
        "#fff",
        "#FFFFFF",
        "#686868",
        "#DDDDDD",
        "#1DAE63",
        "#EE2E24",
        "#f9f0f0",
        "#bf1601",
        "#f3f3f3",
        "red",
        "rgba(0, 0, 0, .13)"
      ]
    },
    "semantic": {
      "background": "#FFFFFF",
      "surface": "#FFFFFF",
      "surface_elevated": null,
      "border": "#DDDDDD",
      "text_primary": "#8D8D8D",
      "text_secondary": "#686868",
      "text_disabled": null,
      "text_inverse": "#FFFFFF",
      "primary": "#EE2E24",
      "primary_hover": null,
      "primary_active": "#EE2E24",
      "secondary": "#1DAE63",
      "accent": null,
      "success": "#1DAE63",
      "warning": null,
      "error": "#bf1601",
      "info": null
    },
    "dark_mode_overrides": {}
  },
  "typography": {
    "font_body": "'Open Sans', sans-serif",
    "font_display": "'Varela Round', sans-serif",
    "font_mono": null,
    "scale": {
      "xs": "10px",
      "sm": "14px",
      "base": "16px",
      "lg": "18px",
      "xl": "30px",
      "2xl": null
    },
    "weights": [
      "normal",
      "bold"
    ],
    "line_heights": [
      "1.5",
      "1.5em",
      "60px"
    ],
    "letter_spacings": []
  },
  "spacing": {
    "base_unit": "unknown",
    "scale": {
      "1": "5px",
      "2": "10px",
      "3": "15px",
      "4": "16px",
      "5": "20px",
      "6": "24px",
      "7": "30px",
      "8": "40px",
      "9": "50px",
      "10": "100px",
      "11": "150px",
      "12": "250px"
    },
    "component_padding": {
      "form_control": "10px",
      "display_pan": "40px"
    },
    "layout_gaps": {
      "form_group": "2rem"
    }
  },
  "shape": {
    "radius": {
      "sm": "0.25rem",
      "md": ".5rem",
      "lg": null,
      "full": "50%"
    },
    "shadows": {
      "sm": null,
      "md": "0 0 20px -2px rgba(0, 0, 0, .13)",
      "lg": "0 0 20px rgba(0, 0, 0, .13)"
    }
  },
  "breakpoints": {
    "sm": "720px",
    "md": "768px",
    "lg": null,
    "xl": null
  },
  "z_index": {},
  "transitions": {
    "duration_fast": null,
    "duration_base": null,
    "easing_default": null
  },
  "component_tokens": {
    "button": {
      "primary_bg": "#EE2E24",
      "primary_border": "#EE2E24",
      "se_btn_bg": "#1DAE63",
      "se_btn_border": "#1DAE63",
      "text_color": "#fff"
    },
    "input": {
      "height": "50px",
      "text_color": "#8D8D8D",
      "error_border": "#ee2e24",
      "error_bg": "#f9f0f0"
    },
    "card": {
      "shadow": "0 0 20px rgba(0, 0, 0, .13)",
      "padding": "40px"
    },
    "badge": {},
    "nav": {
      "shadow": "0 0 20px -2px rgba(0, 0, 0, .13)"
    },
    "modal": {},
    "table": {}
  },
  "css_variables": {
    "global": {},
    "per_component": {}
  }
}
